import { render, staticRenderFns } from "./DesignContent5.vue?vue&type=template&id=41ef0cb6&"
import script from "./DesignContent5.vue?vue&type=script&lang=ts&"
export * from "./DesignContent5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports